export const determineDateValuesFromIso = (isoDate: string) => {
  if (!isoDate) {
    return null;
  }
  const parts = isoDate.split('T')[0].split('-');
  if (parts.length !== 3) {
    return null;
  }
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);
  return { year, month, day };
};

export const determineDateObjectFromIso = (isoDate: string) => {
  const parts = determineDateValuesFromIso(isoDate);
  if (!parts) {
    return null;
  }
  const { year, month, day } = parts;
  return new Date(year, month - 1, day);
};
